/** @format */
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { getSearchParamsFromQuery } from '@toucan/common/services/search/helpers';
import { ModelSearchResultsSearchParams } from '@toucan/common/services/search/types';

export const useSearchParams = (): ModelSearchResultsSearchParams => {
    const router = useRouter();

    const searchParams = useMemo(
        () => getSearchParamsFromQuery(router.query),
        [router.query]
    );

    return searchParams;
};
